/*

两种方式读取统一配置:

一、
this.config.getUValue('JQIMC:common:ns_ip', '默认值')
.then(
	d=>console.log(d),
	e=>console.error(e));

二、
this.config.getUValue({
	syscode: '',
	key: 'common',
	path: 'ns_ip'
}, '默认值')
.then(
	d=>console.log(d),
	e=>console.error(e));

其中，syscode 可以不写，默认为 JQIMC；path 可以不写，默认返回一个 UConfig 实例.

读取全部配置：

this.config.getUConfig(cnfKey, syscode)
	.then(cnf=>{
		console.log(cnf);
	})
	.catch(e=>console.error(e));

*/

import utils from '../utils'
import cnf from './src/config'
import ZJApis from '../api'

let global = window || {};

const SYSCODE = 'JQIMC';

const UConfig = function(opts) {
    this.extend(opts || {})
};

// JSON Value
Object.defineProperty(UConfig.prototype, "JValue", {
    configurable: false,
    enumerable: false,
    get() {
        if (typeof this.$jvalue === 'undefined') {
            const jvalue = JSON.parse(this.UValue);
            this.$jvalue = jvalue;
        }
        return this.$jvalue;
    }
});

UConfig.prototype.isList = function() {
    return this.UKeyType && this.UKeyType == 2;
};

UConfig.prototype.getValue = function(key, def) {
    if (!key) return this.UValue;
    let val = undefined;
    if (this.isList()) {
        utils.each(this.JValue, x=>{
            if (x.ItemKey == key) {
                val = x.Extend1;
                return false;
            }
        });
    }
    else {
        val = utils.selectJSON(this.JValue, key);
    }
    return typeof val === 'undefined' ? def : val;
};

const ZJConfig = function(opts) {
    this.cache = {}; // 缓存统一配置
    this.extend(opts || {})
}

ZJConfig.prototype.extend = UConfig.prototype.extend = function() {
    return utils.extend.apply(this, [this, ...arguments])
}

// 参数：
//   key - 待读取的配置的 Key
//   def - 当配置项不存在时的默认值
ZJConfig.prototype.getValue = function(key, def) {
    let value = utils.selectJSON(this, key);
    if (typeof value !== 'undefined')
        return value;
    return def;
}

// 加载配置
ZJConfig.prototype.load = function(opts) {
    var that = this;
    opts = opts || [];
    return new Promise(function (resolve, reject) {
        try {
            that.extend( global.$config || {});
            that.extend( opts.config || {});
            global.$config = global.ZJApp.config = that;
            document.getElementsByTagName("body")[0].style.setProperty("--project", that.app.project);
            resolve(that);
        }
        catch (e) {
            reject(e);
        }
    })
}

// 异步获取统一配置
ZJConfig.prototype.getUConfig = function(key, syscode) {
    const that = this;
    syscode = syscode || SYSCODE;
    return new Promise(function (resolve, reject) {
        try {
            if (!key || typeof key !== 'string') {
                resolve(undefined);
                return;
            }

            const cacheKey = syscode + '.' + key;
            let val;

            that.cache = that.cache || {};
            if (typeof that.cache[cacheKey] !== 'undefined') {
                val = that.cache[cacheKey];
            }
            else {
                const api = new ZJApis.UniformConfigApi();
                val = utils.waitAll([
                    // 读取配置
                    api.GetDataBySearch({
                        SysCode: syscode,
                        Key: key
                    }),
                    // 解析引用
                    d=>{
                        if (d && d.length && d[0] && d[0].data && d[0].data.Data) {
                            return that.resolveRef(d[0].data.Data.UValue);
                        }
                        else {
                            return Promise.reject('Invalid uconfig key "' + syscode + '.' + key + '"');
                        }
                    }
                ], r=>{
                    // 转换结果为 UConfig 实例
                    let d = r[0].data.Data;
                    d.UValue = r[1]; // 使用 resolveRef 函数处理后的 UValue
                    const val = new UConfig(d);
                    that.cache[cacheKey] = val;
                    return val;
                });
                that.cache[cacheKey] = val;
            }

            if (val instanceof Promise) {
                val.then(
                    d=>resolve(d),
                    e=>reject(e));
            }
            else {
                resolve(val);
            }
        }
        catch (e) {
            reject(e);
        }
    });
}

function format(val, fmt) {
    if (!val) return val;
    if (!fmt) return val;
    let fmts = fmt.split(':');
    for (let i = 0;i < fmts.length; i++) {
        let item = fmts[i];
        if (!item) continue;
        switch(item) {
            case 'urlencode':
                val = encodeURIComponent(val);
                break;
            case 'urldecode':
                val = decodeURIComponent(val);
                break;
            default:
                console.error('解析配置引用失败：未知的格式化函数: ' + item);
                break;
        }
    }
}

// 处理引用
ZJConfig.prototype.resolveRef = function(uvalue) {
    const that = this;
    return new Promise(function (resolve, reject) {
        try {
            if (!uvalue || typeof uvalue !== 'string') {
                resolve(uvalue);
                return;
            }

            const dic = {};
            const regex = /\{\$cnf:(?<syscode>[a-zA-Z0-9_ \\./-]*):(?<key>[a-zA-Z0-9_ \\./-]+):(?<path>[a-zA-Z0-9_ \\./-]+)(:(?<fmt>[^}]+))?\}/gi;
            
            const found = [...uvalue.matchAll(regex)];
            let arr = [];
            for (let i = 0;i < found.length; i++) {
                const group = found[i].groups;
                const syscode = group.syscode || SYSCODE,
                    key = group.key;
                const cacheKey = syscode + '.' + key;
                if (dic[cacheKey])
                    continue;
                const promise = that.getUConfig(key, syscode);
                arr.push(promise);
                dic[cacheKey] = promise;
                promise.then(r=>dic[cacheKey] = r);
            }

            utils.waitAll(arr)
            .then(
                ()=>{
                    let newValue = uvalue.replace(regex, function (refstr,syscode,key,path,x,fmt) {
                        syscode = syscode || SYSCODE;
                        const cacheKey = syscode + '.' + key;
                        const d = dic[cacheKey];
                        const v = d.getValue(path);
                        const result = format(v, fmt);
                        return result;
                    });
                    resolve(newValue);
                },
                e=>reject(e)
            );
        }
        catch (e) {
            reject(e);
        }
    });
}

ZJConfig.prototype.parseUKey = function(key) {
    if (typeof key === 'string') {
        let r = {
            syscode: SYSCODE,
            key: '',
            path: ''
        };
        if (key) {
            const regex = /^(?<syscode>[a-zA-Z0-9_ \\./-]*)?:(?<key>[a-zA-Z0-9_ \\./-]+)(:(?<path>[a-zA-Z0-9_ \\./-]+)?)?$/i;
            const reg = key.match(regex);
            if (reg && reg.groups) {
                r.syscode = reg.groups.syscode || SYSCODE;
                r.key = reg.groups.key;
                r.path = reg.groups.path;
            }
        }
        return r;
    }
    else {
        return key;
    }
};

ZJConfig.prototype.getUValue = function (key, def) {
    if (!key) return Promise.reject('"key" can not be empty');
    const that = this;
    return new Promise(function (resolve, reject) {
        let arg = that.parseUKey(key);
        if (!arg) {
            reject('Invalid "key", the key should be in "syscode:key:path" format');
            return;
        }
        const syscode = arg.syscode || SYSCODE;
        const cnfKey = arg.key;
        const path = arg.path;
        if (!syscode || !cnfKey) {
            reject('Invalid "key", the key should be in "syscode:key:path" format');
            return;
        }
        that.getUConfig(cnfKey, syscode)
        .then(cnf=>{
            let value;
            if (path) {
                value = cnf.getValue(path, def);
            }
            else {
                value = cnf;
            }
            resolve(value);
        })
        .catch(e=>resolve(e));
    });
}

ZJConfig.install = function(Vue) {
    // 切换为响应式扩展
    ZJConfig.prototype.extend = UConfig.prototype.extend = function() {
        return Vue.reactiveExtend.apply(this, [this, ...arguments])
    }

    ZJConfig.current = new ZJConfig(cnf);

    // 混入配置
    Vue.mixin({
        data() {
            return {
                zj_config: ZJConfig.current
            }
        },
        computed: {
            BASE_URL() { return ZJConfig.current.getValue('app.base_url', '/') }
        },
        methods: {
            CNF(key,def) { return ZJConfig.current.getValue(key, def) }
        }
    });

    Vue.prototype.config = ZJConfig.current;
}

export default ZJConfig